import { UserContext } from '../App';
import UserButton from './Buttons/UserButton';
import { useContext } from 'react';
import { ASSETS_ROOT } from '../api/config';

function Header({ isAuthenticated, setIsAuthenticated, type, setHeaderType }) {
  const userContext = useContext(UserContext);

  const clubIconUrl = ASSETS_ROOT + userContext.user?.logoUrl;

  return (
    isAuthenticated && (
      <header
        style={{ height: '60px', minHeight: '60px', maxHeight: '60px' }}
        className='bg-white d-flex justify-content-between px-3 px-md-5 py-2 align-items-center border-bottom'
      >
        {type === 'admin' ? (
          <>
            <span className='fs-3 d-none d-sm-block user-select-none'>
              SBF Folkrace administratör
            </span>
            <span className='fs-6 d-block d-sm-none'>
              Folkrace administratör
            </span>
          </>
        ) : (
          <div className='d-flex flex-direction-row justify-content-start align-items-center'>
            {userContext.user?.logoUrl ? (
              <img
                src={clubIconUrl}
                style={{ width: '50px' }}
                className='me-3'
                alt='Klubbikon'
              />
            ) : (
              <>
                <span
                  className='material-symbols-outlined material-symbols-outlined justify-content-center align-items-center me-3'
                  style={{
                    fontSize: '50px',
                    backgroundColor: 'grey',
                    width: '50px',
                    height: '50px',
                  }}
                >
                  flag
                </span>
              </>
            )}
            <span className='fs-3 d-none d-md-block'>
              {userContext.user?.clubName}
            </span>
            <span className='fs-6 d-block d-md-none'>
              {userContext.user?.clubName}
            </span>
          </div>
        )}

        <div className='d-flex justify-content-end align-items-center'>
          <UserButton
            setIsAuthenticated={setIsAuthenticated}
            role={type}
            setHeaderType={setHeaderType}
          />
        </div>
      </header>
    )
  );
}

export default Header;
